module.exports = __webpack_public_path__ + "static/media/b3.8323ca3.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhengqingsheng/b3.mp3
// module id = PfCi
// module chunks = 0